{
  "averageDailyUsage": {
    "title": "Uso diario promedio",
    "unitLabel": "Acre-pulgadas/día"
  },
  "downloadWaterUsageReportButton": "Descargar informe",
  "estimatesWarning": {
    "message": "Los datos que se muestran aquí se derivan de estimaciones históricas y no deben utilizarse en el mantenimiento de registros oficiales.",
    "title": "Visualización de estimaciones históricas"
  },
  "farmWideWaterUsage": {
    "title": "Uso de agua en toda la finca",
    "unitLabel": "Acre-pies"
  },
  "flowSourceToggle": {
    "label": "Fuente de datos:"
  },
  "flowSummaryTable": {
    "headings": {
      "peakFlowRate": "Caudal máximo (GPM)",
      "totalVolumeAcreFeet": "Volumen total (pies ac.)"
    },
    "title": "Resumen del uso del agua en la granja"
  },
  "flowTimeseries": {
    "axisLabels": {
      "y": "Volumen (acre-pies)"
    },
    "title": "Uso a lo largo del tiempo"
  },
  "highestFlowRate": {
    "pumpWithDeviceName": "Bomba: {{deviceName}}",
    "title": "Mayor caudal",
    "unitLabel": "Galones/minuto"
  },
  "noDataFound": "No se encontraron datos para los filtros especificados",
  "peakDailyUsage": {
    "onWithDate": "El {{date, datetime}}",
    "title": "Consumo diario máximo",
    "unitLabel": "Acre-pulgadas"
  },
  "pumpFlowStackedTimeseries": {
    "axisLabels": {
      "y": "Volumen (acre-pies)"
    },
    "title": "Volumen total a lo largo del tiempo"
  },
  "pumpTotalHorizontalBar": {
    "axisLabels": {
      "x": "Volumen (acre-pies)"
    },
    "title": "Volumen total por bomba"
  },
  "title": "Análisis de flujo"
}
